import api from './api';
import { ISignUpDto, ISignInDto, ITokenResponse } from 'interfaces/auth.interface';

export const signUp = (data: ISignUpDto): Promise<ITokenResponse> => {
  return api.post('auth/sign-up', data);
};

export const signIn = (data: ISignInDto): Promise<ITokenResponse> => {
  return api.post('auth/sign-in', data);
};
